module.exports = __webpack_public_path__ + "media/audio70.bcaa76d0.mp3";